<template>
  <ion-modal class="admin-releases-modal" :is-open="isOpen" @didDismiss="$emit('done')">
    <ion-header>
      <ion-toolbar>
        <ion-title>Liga.Chat</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <h2 class="onboarding-title">Общайтесь внутри Liga.Chat</h2>
      <p class="onboarding-text">
        По умолчанию ваш профиль максимально приватный: вас не видно в поиске, и новые личные сообщения закрыты.
      </p>
      <p class="onboarding-text onboarding-text--encrypt">
        Личные, групповые и публичные чаты защищены клиентским шифрованием (E2E): текст сообщений на сервере
        хранится в зашифрованном виде, ключи расшифровки остаются на устройствах участников. Чат поддержки и
        системные уведомления для работы сервиса передаются без такого шифрования.
      </p>
      <div class="onboarding-settings">
        <MessengerPrivacySettingsInline v-if="privacy" :privacy="privacy" @change="privacy = $event" />
      </div>
      <ion-button class="messenger-primary-btn" expand="block" @click="save">Сохранить</ion-button>
      <ion-button class="messenger-clear-btn" expand="block" fill="clear" @click="later">Настроить позже</ion-button>
    </ion-content>
  </ion-modal>
</template>

<script lang="ts">
import { IonButton, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from '@ionic/vue';
import { defineComponent } from 'vue';
import MessengerService, { IMessengerPrivacy } from '@/services/messenger.service';
import MessengerPrivacySettingsInline from './MessengerPrivacySettingsInline.vue';

export default defineComponent({
  name: 'MessengerOnboardingModal',
  components: { IonButton, IonContent, IonHeader, IonModal, IonTitle, IonToolbar, MessengerPrivacySettingsInline },
  emits: ['done'],
  props: { isOpen: { type: Boolean, required: true } },
  data() {
    return { service: new MessengerService(), privacy: null as IMessengerPrivacy | null };
  },
  watch: {
    isOpen(value: boolean) {
      if (value) void this.load();
    },
  },
  methods: {
    async load() {
      this.privacy = await this.service.getPrivacy();
    },
    async save() {
      if (this.privacy) {
        this.privacy.onboardingSeen = true;
        await this.service.updatePrivacy(this.privacy);
      }
      this.$emit('done');
    },
    async later() {
      const privacy = this.privacy || (await this.service.getPrivacy());
      privacy.onboardingSeen = true;
      await this.service.updatePrivacy(privacy);
      this.$emit('done');
    },
  },
});
</script>

<style scoped>
.onboarding-title {
  margin: 0 0 8px;
  color: var(--liga-chrome-text, #fff);
  font-family: Montserrat, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
}
.onboarding-text {
  margin: 0 0 12px;
  color: var(--liga-chrome-text-muted, rgba(255, 255, 255, 0.75));
  line-height: 1.45;
}
.onboarding-text--encrypt {
  margin-bottom: 16px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(235, 89, 82, 0.12);
  border: 1px solid rgba(235, 89, 82, 0.28);
  color: var(--liga-chrome-text, rgba(255, 255, 255, 0.88));
  font-size: 0.92rem;
}
.onboarding-settings {
  margin-bottom: 18px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--liga-float-glass-border);
  overflow: hidden;
}
.messenger-primary-btn {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --color: var(--liga-chrome-text);
  --border-radius: 14px;
  font-weight: 600;
  margin-top: 8px;
}
.messenger-clear-btn {
  --color: var(--ion-color-orange);
  font-weight: 600;
}
</style>
